import 'core-js/features/set';
import 'core-js/features/map';
import 'core-js/es/set';
import 'core-js/es/map';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';


ReactDOM.render(<App/>, document.getElementById('root'));
